import React from 'react'

import { LntFormGroup, LntFormItem, LntInput } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'

import styles from '../styles.module.scss'

import type { CharacteristicsGroupProps } from './types'

export const CharacteristicsGroup: React.FC<CharacteristicsGroupProps> = ({ dataSource, disabled }) => {
  return (
    <LntFormGroup label='Характеристики основного товара'>
      <div className={ styles.productCardForm__groupWrapper }>
        <LntFormItem
          name='manufacturer'
          defaultValue={ dataSource?.manufacturer }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.manufacturer }
          />
        </LntFormItem>

        <LntFormItem
          name='regionManufacturer'
          defaultValue={ dataSource?.regionManufacturer }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.regionManufacturer }
          />
        </LntFormItem>

        <LntFormItem
          name='brand'
          defaultValue={ dataSource?.brand }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.brand }
          />
        </LntFormItem>

        <LntFormItem
          name='categoryEggs'
          defaultValue={ dataSource?.categoryEggs }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.categoryEggs }
          />
        </LntFormItem>

        <LntFormItem
          name='shell'
          defaultValue={ dataSource?.shell }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.shell }
          />
        </LntFormItem>

        <LntFormItem
          name='productForm'
          defaultValue={ dataSource?.productForm }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.productForm }
          />
        </LntFormItem>

        <LntFormItem
          name='packaging'
          defaultValue={ dataSource?.packaging }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.packaging }
          />
        </LntFormItem>

        <LntFormItem
          name='fatContentOrFortress'
          defaultValue={ dataSource?.fatContentOrFortress }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.fatContentOrFortress }
            suffix='%'
          />
        </LntFormItem>
        <LntFormItem
          name='volumeMl'
          defaultValue={ dataSource?.volumeMl }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.volumeMl }
            type='number'
            suffix='мл'
          />
        </LntFormItem>

        <LntFormItem
          name='volumeG'
          defaultValue={ dataSource?.volumeG }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.volumeG }
            type='number'
            suffix='г'
          />
        </LntFormItem>

        <LntFormItem
          name='volumePieces'
          defaultValue={ dataSource?.volumePieces }
        >
          <LntInput
            disabled={ disabled }
            className={ styles.productCardForm__item }
            placeholder={ FILTERS_PLACEHOLDERS.volumePieces }
            type='number'
            suffix='шт'
          />
        </LntFormItem>
      </div>
    </LntFormGroup>
  )
}
